const STORAGE_KEY_PREFIX = 'cw-conversation-tabs';

const getStorageKey = accountId => `${STORAGE_KEY_PREFIX}-${accountId}`;

const loadTabsFromStorage = accountId => {
  try {
    const data = localStorage.getItem(getStorageKey(accountId));
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const saveTabsToStorage = (accountId, tabs) => {
  try {
    localStorage.setItem(getStorageKey(accountId), JSON.stringify(tabs));
  } catch {
    // Ignore storage errors
  }
};

const state = {
  tabs: [],
  currentAccountId: null,
};

const getters = {
  getTabs: _state => _state.tabs,
  isTabOpen: _state => conversationId =>
    _state.tabs.some(t => t.conversationId === conversationId),
};

const mutations = {
  SET_ACCOUNT(_state, accountId) {
    _state.currentAccountId = accountId;
    _state.tabs = loadTabsFromStorage(accountId);
  },
  ADD_TAB(_state, { conversationId, contactName, avatarUrl }) {
    if (_state.tabs.some(t => t.conversationId === conversationId)) return;
    _state.tabs.push({ conversationId, contactName, avatarUrl });
    saveTabsToStorage(_state.currentAccountId, _state.tabs);
  },
  REMOVE_TAB(_state, conversationId) {
    _state.tabs = _state.tabs.filter(t => t.conversationId !== conversationId);
    saveTabsToStorage(_state.currentAccountId, _state.tabs);
  },
  UPDATE_TAB(_state, { conversationId, contactName, avatarUrl }) {
    const tab = _state.tabs.find(t => t.conversationId === conversationId);
    if (tab) {
      if (contactName !== undefined) tab.contactName = contactName;
      if (avatarUrl !== undefined) tab.avatarUrl = avatarUrl;
      saveTabsToStorage(_state.currentAccountId, _state.tabs);
    }
  },
  CLEAR_TABS(_state) {
    _state.tabs = [];
    saveTabsToStorage(_state.currentAccountId, []);
  },
};

const actions = {
  setAccount({ commit }, accountId) {
    commit('SET_ACCOUNT', accountId);
  },
  addTab({ commit }, payload) {
    commit('ADD_TAB', payload);
  },
  removeTab({ commit }, conversationId) {
    commit('REMOVE_TAB', conversationId);
  },
  updateTab({ commit }, payload) {
    commit('UPDATE_TAB', payload);
  },
  clearTabs({ commit }) {
    commit('CLEAR_TABS');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
